// Process-wide counter of in-flight media uploads (images via
// components/shared/uploader.js, videos via videos/upload_video.js).
//
// Consumers that would destroy an in-flight upload check hasActiveUploads()
// before acting — the motivating case is capacitor/resume_refresh.js, which
// hard-reloads the webview after a long background: image uploads have no
// resume, so a reload mid-transfer loses the user's photo outright.

let activeCount = 0;

// Marks an upload as started. Returns an idempotent `end` function the caller
// MUST invoke when the upload settles (success or failure) — typically from a
// `finally`.
export function beginUploadActivity() {
  activeCount += 1;
  let ended = false;
  return function endUploadActivity() {
    if (ended) return;
    ended = true;
    activeCount = Math.max(0, activeCount - 1);
  };
}

export function hasActiveUploads() {
  return activeCount > 0;
}

// Test-only: reset the counter between cases without reaching into module state.
export function __resetUploadActivityForTests() {
  activeCount = 0;
}
